import React from "react";
import { FormFieldTypes } from "../../../../data/formFieldType";

export const CompanyDetailsFormData = {
  name: "CompanyDetails",
  initialState: {
    registeredCompanyName: "",
    uENNumber: "",
    typeofCompany: null,
    organisationProfile: null,
    businessCategories: null,
    organisationCategory: null,
    others: "",
    productsandServicesOfferedbyOrganisation : null,
    otherproductsandServices:"",
    typeOfProduct: '',
    describeTheWays: '',
    companyDescription: '',
    areyouaPSPCListedOrganisation: "no",
    pspcListedOrganisation: null,
    anyotherinformationtobeprovidedtosgbc: "",
    reasonforjoiningSGBCCorporateMembership: null,
    howdidyoulearnaboutsgbc: null,
    otherReasonOfJoining:"",
    otherInformationAboutSGBC:""
  },
  formFields: [
    {
      id: "registeredCompanyName",
      lable: "Registered Company Name (as per ACRA or Registry records)",
      Field_Name: "Registered Company Name (as per ACRA or Registry records)",
      fieldType: FormFieldTypes.INPUT,
      dataField: "registeredCompanyName",
      fieldSetting: {
        placeholder: "",
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "uENNumber",
      lable: "UEN / Company Registration Number",
      Field_Name: "UEN / Company Registration Number",
      fieldType: FormFieldTypes.INPUT,
      dataField: "uENNumber",
      fieldSetting: {
        placeholder: "",
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "typeofCompany",
      lable: "Country of Incorporation",
      Field_Name: "Country of Incorporation",
      fieldType: FormFieldTypes.SELECT,
      dataField: "typeofCompany",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "organisationProfile",
      lable: "Organisation Profile",
      Field_Name: "Organisation Profile",
      fieldType: FormFieldTypes.SELECT,
      dataField: "organisationProfile",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "businessCategories",
      lable: "Business Categories",
      Field_Name: "Business Categories",
      fieldType: FormFieldTypes.SELECT,
      dataField: "businessCategories",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
     {
      id: "organisationCategory",
      lable: "Organisation Category",
      Field_Name: "Organisation Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "organisationCategory",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "others",
      lable: "Others",
      Field_Name: "Others",
      fieldType: FormFieldTypes.INPUT,
      dataField: "others",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable:true
      },
      validation: [],
      style: {
        containerCss: "col-md-5 mb-3 mt-auto d-none",
      },
    },
    {
      id: "productsandServicesOfferedbyOrganisation",
      lable: "Products and Services Offered by Organisation",
      Field_Name: "Products and Services Offered by Organisation",
      fieldType: FormFieldTypes.SELECT,
      dataField: "productsandServicesOfferedbyOrganisation",
      fieldSetting: {
        placeholder: "Select",
        isMultiSelect: true,
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-5 mb-3",
      },
    },
   
     
     {
      id: "otherproductsandServices",
      lable: "Other Consultancies; Please specify",
      Field_Name: "Other Consultancies; Please specify",
      fieldType: FormFieldTypes.INPUT,
      dataField: "otherproductsandServices",
      fieldSetting: {
       placeholder: "",
       allowSpace: true,
       isDisable:true
      },
      style: {
        containerCss: "col-md-5 mb-3",
      },
    },
    {
      id: "typeOfProduct",
      lable: "Type of Product(s) or Services(s)",
      Field_Name: "Type of Product(s) or Services(s)",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "typeOfProduct",
      fieldSetting: {
        placeholder: "",
        textareaRows:5
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-10 mb-2 mb-3",
      },
    },
    {
      id: "describeTheWays",
      lable: "Describe the ways in which new or existing business will be involved in the green building movement",
      Field_Name: "your organisation’s green building movement involvement",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "describeTheWays",
      fieldSetting: {
        placeholder: "",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-10 mb-2 mb-3",
      },
    },
    {
      id: "companyDescription",
      lable: "Company Description",
      Field_Name: "Company Description",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "companyDescription",
      fieldSetting: {
        placeholder: "",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-10 mb-2 mb-3",
      },
    },
    {
      id: "areyouaPSPCListedOrganisation",
      label: <React.Fragment>
        Are you listed on Public Sector Panels of Consultants (PSPC)?<br></br>Check full listing { " " }
        <a
          href="https://pspc.bca.gov.sg/#/pspc/listing/default"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
      </React.Fragment>,
      Field_Name: "Are you listed on Public Sector Panels of Consultants (PSPC)? Check full listing here ",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "areyouaPSPCListedOrganisation",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "yes", isDisable: false },
          { label: "No", value: "no", isDisable: false, optionClass: "mr-3" },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 col-12 mb-4 mt-2 x-position",
      },
    },
    {
      id: "pspcListedOrganisation",
      lable: "Please select your panel below:",
      Field_Name: "PSPC Listed Organisation",
      fieldType: FormFieldTypes.SELECT,
      dataField: "pspcListedOrganisation",
      fieldSetting: {
        placeholder: "",
        options: [],
        isMultiSelect: true,
      },
      validation: [],
      style: {
        containerCss: "col-lg-5 mb-2 d-none",
      },
    },
    {
      id: "Other Information",
      lable: "",
      Field_Name: "Other Information",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "Other Information",
      fieldSetting: {
        formTitle: "Other Information",
      },
      style: {
        containerCss: "main-sub-title",
      },
    },
    {
      id: "howdidyoulearnaboutsgbc",
      lable: "How did you learn about SGBC",
      Field_Name: "How did you learn about SGBC",
      fieldType: FormFieldTypes.SELECT,
      dataField: "howdidyoulearnaboutsgbc",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isMultiSelect: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3  ",
      },
    },
    {
      id: "otherInformationAboutSGBC",
      lable: "Others; please specify",
      Field_Name: "Others; please specify",
      fieldType: FormFieldTypes.INPUT,
      dataField: "otherInformationAboutSGBC",
      fieldSetting: {
        placeholder: "Enter details here",
        // isDisable: true,
      },
      validation: [],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3 d-none",
      },
    }
    ,

    {
      id: "anyotherinformationtobeprovidedtosgbc",
      lable: "Do you wish to provide any other information to SGBC?",
      Field_Name: "Do you wish to provide any other information to SGBC?",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "anyotherinformationtobeprovidedtosgbc",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-md-10 mb-3",
      },
    },

    {
      id: "reasonforjoiningSGBCCorporateMembership",
      lable: "Reasons for joining SGBC Corporate Membership",
      Field_Name: "Reasons for joining SGBC Corporate Membership",
      fieldType: FormFieldTypes.SELECT,
      dataField: "reasonforjoiningSGBCCorporateMembership",
      fieldSetting: {
        placeholder: "",
        options: [],
        isMultiSelect: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2",
      },
    },
    {
      id: "otherReasonOfJoining",
      lable: "Recommended By / Others; please specify",
      Field_Name: "Recommended By / Others; please specify",
      fieldType: FormFieldTypes.INPUT,
      dataField: "otherReasonOfJoining",
      fieldSetting: {
        placeholder: "",
        options: [],
      },
      validation: [],
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 d-none",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
